import { CForms } from "../Generated/CClasses"
import { LoginData } from "../Types";

export class VVZLogin {

    public backend : CForms;
    
    public loginData : LoginData;
    
    window: Window | null;
    
    public async getLoginData(): Promise<LoginData> {
        this.loginData = await this.backend.GetLoginInfo("aa");
        return this.loginData;
    }

    public async login() : Promise<LoginData> {
        return new Promise(async resolve => {
            await this.getLoginData();
            window._vvzloginCallback = async () => {
                resolve(await this.getLoginData());
                this.window?.close();
            };
            this.window = window.open(this.loginData.LoginUrl);
        });
    }

    public async logout() : Promise<LoginData> {
        if (!this.loginData.IsLogged) return
        return new Promise(async resolve => {
            window._vvzloginCallback = async () => {
                resolve(await this.getLoginData());
                this.window?.close();
            };
            this.window = window.open(this.loginData.LogoutUrl);
        });
    }
}